




































import AbpBase from "@/lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '@/lib/util'
import {
  GetBindingLaboratoryIndicatorsList,
  GetLaboratoryIndicatorsList,
  GetAllIndicator,
  BatchSaveBindingLaboratoryIndicator
} from "@/api/laboratoryCategories";
import editBindingIndicators from "./editBindingIndicators.vue";
@Component({components: { editBindingIndicators}})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    title="";
    fuzzyQuery="";
    bingdings:any=[];
    indicators:any=[];
    indicatorsAll:any=[];
    selectedTableRow:any=[];
    selectedTable2Row:any=[];
    editBingdingData:any={};
    editShow=false;
    loading=false;
    indicatorsColumn = [
        {
            type: "selection",
            width: 60,
            align: "center",
        },
        {
            title: "指标编码",
            key: "itemCode",
            minWidth: 120,
        },
        {
            title: "指标名称",
            key: "itemName",
            minWidth: 120,
        },
        {
            title: "单位",
            key: "unit",
            width: 80,
        },
        {
            title: "样本",
            key: "sampleClass",
            minWidth: 120,
        },
        {
            title: "报告总数量",
            key: "reportNum",
            width: 120,
        },
        {
            title: "值类型",
            key: "valueType",
            width: 80,
        },
    ];

    bingdingColumn = [
    {
        type: "selection",
        width: 60,
        align: "center",
    },
    {
        title: "指标编码",
        key: "itemCode",
        minWidth: 120,
    },
    {
        title: "指标名称",
        key: "itemName",
        minWidth: 120,
    },
    {
        title: "单位",
        key: "unit",
        width: 80,
    },
    {
        title: "样本",
        key: "sampleClass",
        minWidth: 120,
    },
    {
        title: "换算",
        key: "conversion",
        width: 70,
    },
    {
        title: "值类型",
        key: "valueType",
        width: 80,
    },
    {
    title: "操作",
    width: 180,
    render: (h1: any, params: any) => {
        const h = this.$createElement;
        let isdefaultDom: any;
        return h("div", [
            isdefaultDom,
            h(
                "Button",
                {
                props: {
                    type: "primary",
                    size: "small",
                },
                style: {
                    marginRight: "15px",
                },
                on: {
                    click: () => {
                        this.editData(params.row,params.index);
                    },
                },
                },
                "编辑"
            ),
            h(
                "Button",
                {
                props: { type: "error", size: "small" },
                on: {
                    click: () => {
                        this.delData(params.row,params.index);
                    },
                },
                },
                "删除"
            ),
            ]);
        },
        },
    ];
    //表格高度
    get tableHeight() {
        return window.innerHeight - 200;
    }
    async created() 
    {
        this.title = this.data.itemName +" 调整";
        this.fuzzyQuery = this.data.fuzzyQuery;
        this.getData();
    }
    //获取数据
    async getData(){
        if(!this.fuzzyQuery.trim()){
            this.$Message.error('请输入指标查询内容！')
            return;
        }
        this.selectedTableRow=[];
        this.selectedTable2Row=[];
        let res = await GetAllIndicator({fuzzyQuery:this.fuzzyQuery});
        if (res && res.objects) {
            this.indicatorsAll = res.objects;
        } else {
            this.indicatorsAll = [];
        }
        let res2 = await GetBindingLaboratoryIndicatorsList({
            indicatorsId: this.data.indicatorsId,
        });
          if (res2 && res2.objects) {
            this.bingdings = res2.objects;
        } else {
            this.bingdings = [];
        }
        this.$nextTick(() => {
            this.screenIndicator();
        });
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        }
    }
    //单个删除
    async delData(row:any,index:number){
        this.$Modal.confirm({
        title: "提示",
        content: "此操作将永久删除该指标, 是否继续?",
            onOk: async () => {
                this.bingdings.splice(index, 1)
                this.screenIndicator();
            },
        });
    }
    //筛选指标
    screenIndicator(){
        this.selectedTableRow=[];
        this.selectedTable2Row=[];
        this.indicators = this.indicatorsAll.filter((item) => {
            var bingding = this.bingdings.find((x) => {
                return x.itemCode == item.itemCode && x.itemName == item.itemName && x.unit == item.unit && x.sampleClass == item.sampleClass;
            });
            return !bingding;
        });
    }
    //修改定性定量或换算
    editData(row:any,index:number){
        this.editBingdingData = row;
        this.editBingdingData.saveType="编辑";
        this.editBingdingData.index = index;
        this.editShow = true;
    }
    async refreshData(){
        console.log(this.editBingdingData);
        if(this.editBingdingData.saveType=="批量添加"){
            let bingdingList = this.selectedTableRow.map((row) => {
                return row;
            });
            bingdingList.forEach(item => {
                this.bingdings.push({
                    itemCode:item.itemCode,
                    itemName:item.itemName,
                    unit:item.unit,
                    sampleClass:item.sampleClass,
                    conversion:this.editBingdingData.conversion,
                    valueType:this.editBingdingData.valueType,
                })
            });
            this.screenIndicator();
        }
        else{
            this.bingdings[this.editBingdingData.index].conversion = this.editBingdingData.conversion;
            this.bingdings[this.editBingdingData.index].valueType = this.editBingdingData.valueType;
        }
    }
    //勾选
    tableSelectionChange(selection: any) {
        this.selectedTableRow = selection;
    }
    //勾选
    tableSelectionChange2(selection: any) {
        this.selectedTable2Row = selection;
    }
    //批量删除
    async batchDelete(){
            this.$Modal.confirm({
            title: "提示",
            content: "此操作将永久删除勾选的指标, 是否继续?",
            onOk: async () => {
                this.bingdings = this.bingdings.filter((item) => {
                    var selected = this.selectedTable2Row.find((x) => {
                        return x.itemCode == item.itemCode && x.itemName == item.itemName && x.unit == item.unit && x.sampleClass == item.sampleClass;
                    });
                    return !selected;
                });
                this.screenIndicator();
            },
        });
    }
    //批量绑定
    batchBingding()
    {
        if(this.selectedTableRow.length<=0) {
            this.$Message.error("请勾选需要的指标！");
            return;
        }
        this.editBingdingData = Object.assign({},this.data);
        this.editBingdingData.saveType="批量添加";
        this.editBingdingData.valueType = this.selectedTableRow[0].valueType
        this.editBingdingData.itemName = this.data.itemName
        this.editShow = true;
    }
    async save(){
        this.loading=true;
        let data ={
            indicatorsId:this.data.indicatorsId,
            bingdings:this.bingdings
        }
        let res = await BatchSaveBindingLaboratoryIndicator(data)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-success')
        }
        this.loading=false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/bindingLaboratoryIndicators.vue